/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Offeringphase2Inputs */

const en_usermanagement_help_offeringphase2 = /** @type {(inputs: Usermanagement_Help_Offeringphase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`During the <b>Offering Phase</b>, users are invited to assist in making investment decisions and completing the necessary subscription documents. This phase includes actions such as managing access to data rooms and signing documents.`)
};

/**
* | output |
* | --- |
* | "During the <b>Offering Phase</b>, users are invited to assist in making investment decisions and completing the necessary subscription documents. This phase ..." |
*
* @param {Usermanagement_Help_Offeringphase2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_offeringphase2 = /** @type {((inputs?: Usermanagement_Help_Offeringphase2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Offeringphase2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_offeringphase2(inputs)
});
export { usermanagement_help_offeringphase2 as "userManagement_help_offeringPhase" }